import { render, staticRenderFns } from "./BatchDialog.vue?vue&type=template&id=27b7d8e4&scoped=true"
import script from "./BatchDialog.vue?vue&type=script&lang=js"
export * from "./BatchDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchDialog.vue?vue&type=style&index=0&id=27b7d8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b7d8e4",
  null
  
)

export default component.exports